import React from 'react';

const PageBanner = ({ title }) => {
  // Handle specific titles with custom formatting
  const renderTitle = () => {
    switch (title) {
      case 'About Vuzo':
        return (
          <h1 className="text-[35px] lg:text-[76px] leading-none font-bold">
            <span className="text-white">About</span>
            <br />
            <span className="text-[#28F5AB]">Vuzo</span>
          </h1>
        );
      case 'Terms of Service':
        return (
          <h1 className="text-[35px] lg:text-[76px] leading-none font-bold">
            <span className="text-white">Terms of</span>
            <br />
            <span className="text-[#28F5AB]">Service</span>
          </h1>
        );
      case 'Privacy Notice':
        return (
          <h1 className="text-[35px] lg:text-[76px] leading-none font-bold">
            <span className="text-white">Privacy</span>
            <br />
            <span className="text-[#28F5AB]">Notice</span>
          </h1>
        );
      case 'Frequently Asked Questions':
        return (
          <h1 className="text-[35px] lg:text-[76px] leading-none font-bold">
            <span className="text-white">Frequently Asked</span>
            <br />
            <span className="text-[#28F5AB]">Questions</span>
          </h1>
        );
      case 'Disclaimer':
        return (
          <h1 className="text-[35px] lg:text-[76px] leading-none font-bold mt-[39px]">
            <span className="text-white align-middle mt-[30px]">Disclaimer</span>
          </h1>
        );
        case 'Contact':
          return (
            <div className="grid lg:grid-cols-2 gap-2 items-center">
              <div>
                <h1 className="text-[35px] lg:text-[76px] leading-none font-bold">
                  <span className="text-white">All set -</span>
                  <br />
                  <span className="text-[#28F5AB]">Let's Talk</span>
                </h1>
              </div>
              <div>
                <p className="text-[#F4EDEA] text-[16px] leading-relaxed">
                  We'd love to hear from you! Please fill out the form below,<br/> and we'll get back to you as soon as possible.
                </p>
              </div>
            </div>
          );
        default:
        // Default behavior for other titles
        const words = title.split(' ');
        const lastWord = words.pop();
        const firstPart = words.join(' ');
        return (
          <h1 className="text-[35px] lg:text-[76px] leading-none font-bold">
            <span className="text-white">{firstPart}</span>{' '}
            <span className="text-white align-middle">{lastWord}</span>
          </h1>
        );
    }
  };

  return (
    <div className="relative bg-black py-16 overflow-hidden min-h-[200px] md:min-h-[290px]">
      {/* Subtle green gradient background effect */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-[800px] h-[400px] blur-2xl" style={{background: 'radial-gradient(circle at center 100%, #1A694E 20%, #022017 50%, #010101 10%)'}}></div>
      </div>
      <div className="relative z-10 mx-auto px-4 text-left">
        {renderTitle()}
      </div>
    </div>
  );
};

export default PageBanner;
